<po-page-list #pageListComponent [p-breadcrumb]="breadcrumb" p-title="Cadastro - Clientes"
    [p-disclaimer-group]="disclaimerGroup" [p-actions]="pageActions" [p-filter]="filterSettings" p-subtitle="Consulte os dados cadastrados no sistema.">

    <div class="page-summary">
      <div class="page-summary-icon">
        <i class="an an-buildings"></i>
      </div>
      <div class="page-summary-text">
        <p class="po-font-subtitle">Verifique todos os Clientes incluídos no sistema.</p>
        <p class="page-summary-hint">Utilize a busca para filtrar por Razão Social, CNPJ, Cidade ou Contato. Atalhos: <kbd>Ctrl+B</kbd> Novo · <kbd>Ctrl+F</kbd> Pesquisar</p>
      </div>
      @if (tableItens.length > 0) {
        <div class="page-summary-counter">
          <span class="counter-value">{{ tableItens.length }}</span>
          <span class="counter-label">registros</span>
        </div>
      }
    </div>

    <po-divider></po-divider>

    <div class="po-row po-mb-4 shadow">
        <div>
            <po-loading-overlay [hidden]="isHideLoading"></po-loading-overlay>
        </div>
        <po-table #dynamicTable p-container="border" [p-actions]="actions" class="po-mr-1 po-ml-1 po-lg-12" #wppTable
            (p-show-more)="loadMore()"
            [p-show-more-disabled]="!moreItens" p-striped="true" p-text-wrap="true"
            [p-loading-show-more]="!isHideLoading"
            [p-spacing]="poTableColumnSpacing" p-container="border" p-hide-columns-manager="false"
            [p-columns]="columns" [p-items]="tableItens">
            <ng-template p-table-column-template [p-property]="'razaoSocial'" let-value>
                <span class="client-name">
                  <i class="an an-buildings client-name-icon"></i>
                  <span [innerText]="value" class="po-font-text-large-bold po-font-text-uppercase"></span>
                </span>
            </ng-template>
            <ng-template p-table-column-template [p-property]="'cnpj'" let-value>
                <span class="cnpj-badge">{{ value }}</span>
            </ng-template>
            <ng-template p-table-column-template [p-property]="'uf'" let-value>
                <span class="uf-badge">{{ value }}</span>
            </ng-template>
            <ng-template p-table-column-template [p-property]="'telefone'" let-value>
              @if (value) {
                <span class="phone-text"><i class="an an-phone"></i> {{ value }}</span>
              }
            </ng-template>
            <ng-template p-table-column-template [p-property]="'contato'" let-value>
              @if (value) {
                <span class="contact-text"><i class="an an-user"></i> {{ value }}</span>
              }
            </ng-template>
        </po-table>
    </div>
</po-page-list>
